"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AE = void 0;
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const Article_1 = require("../Article");
const echain_product_models_1 = require("@igus/echain-product-models");
class ZubehoerRef {
    constructor(model) {
        this.model = model;
    }
    get montagesetId() {
        return this.model.MontagesetId;
    }
    set montagesetId(value) {
        this.model.MontagesetId = value;
    }
    get kettenSerieId() {
        return this.model.KettenSerieId;
    }
    set kettenSerieId(value) {
        this.model.KettenSerieId = value;
    }
    get biMin() {
        return (0, echain_shared_quantities_1.Q)(this.model.BiMin);
    }
    set biMin(value) {
        this.model.BiMin = value.quantity;
    }
}
/**
 * The class `AE` is a Value Object representing an igus AE article.
 */
class AE extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'AE';
    }
    get aufbauId() {
        return this.model.AufbauId;
    }
    set aufbauId(value) {
        this.model.AufbauId = value;
    }
    get befestigungsvariante() {
        return this.model.Befestigungsvariante;
    }
    set befestigungsvariante(value) {
        this.model.Befestigungsvariante = value;
    }
    get color() {
        return this.model.Color;
    }
    set color(value) {
        this.model.Color = value;
    }
    get festpunktGerade() {
        return this.model.FestpunktGerade;
    }
    set festpunktGerade(value) {
        this.model.FestpunktGerade = value;
    }
    get festpunktUngerade() {
        return this.model.FestpunktUngerade;
    }
    set festpunktUngerade(value) {
        this.model.FestpunktUngerade = value;
    }
    get gewicht() {
        return echain_shared_quantities_1.Q.optional(this.model.Gewicht);
    }
    set gewicht(value) {
        this.model.Gewicht = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get ketteRef() {
        return this.model.KetteRef;
    }
    set ketteRef(value) {
        this.model.KetteRef = value;
    }
    get komplettsatzGerade() {
        return this.model.KomplettsatzGerade;
    }
    set komplettsatzGerade(value) {
        this.model.KomplettsatzGerade = value;
    }
    get komplettsatzUngerade() {
        return this.model.KomplettsatzUngerade;
    }
    set komplettsatzUngerade(value) {
        this.model.KomplettsatzUngerade = value;
    }
    get laenge() {
        return echain_shared_quantities_1.Q.optional(this.model.Laenge);
    }
    set laenge(value) {
        this.model.Laenge = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get mitnehmerGerade() {
        return this.model.MitnehmerGerade;
    }
    set mitnehmerGerade(value) {
        this.model.MitnehmerGerade = value;
    }
    get mitnehmerUngerade() {
        return this.model.MitnehmerUngerade;
    }
    set mitnehmerUngerade(value) {
        this.model.MitnehmerUngerade = value;
    }
    get montiert() {
        return this.model.Montiert;
    }
    set montiert(value) {
        this.model.Montiert = value;
    }
    get properties() {
        return this.model.Properties;
    }
    set properties(value) {
        this.model.Properties = value;
    }
    get zubehoerRef() {
        return this.model.ZubehoerRef.map((i) => new ZubehoerRef(i));
    }
    set zubehoerRef(value) {
        this.model.ZubehoerRef = value.map((i) => i.model);
    }
    get zugentlastungTyp() {
        return this.model.ZugentlastungTyp;
    }
    set zugentlastungTyp(value) {
        this.model.ZugentlastungTyp = value;
    }
    get zweiteilig() {
        return this.model.Zweiteilig;
    }
    set zweiteilig(value) {
        this.model.Zweiteilig = value;
    }
    get material() {
        return this.model.Material;
    }
    set material(value) {
        this.model.Material = value;
    }
    get application() {
        return this.model.Application;
    }
    set application(value) {
        this.model.Application = value;
    }
    get festpunkt() {
        return this.model.Festpunkt;
    }
    set festpunkt(value) {
        this.model.Festpunkt = value;
    }
    get mitnehmer() {
        return this.model.Mitnehmer;
    }
    set mitnehmer(value) {
        this.model.Mitnehmer = value;
    }
    get komplettsatz() {
        return this.model.Komplettsatz;
    }
    set komplettsatz(value) {
        this.model.Komplettsatz = value;
    }
    get gliedanzahlAbhaengig() {
        return this.model.GliedAnzahlAbhaengig;
    }
    set gliedanzahlAbhaengig(value) {
        this.model.GliedAnzahlAbhaengig = value;
    }
    get typ() {
        return this.model.Typ;
    }
    set typ(value) {
        this.model.Typ = value;
    }
    get variante() {
        return this.model.Variante;
    }
    set variante(value) {
        this.model.Variante = value;
    }
    get ausrichtung() {
        return this.model.Ausrichtung;
    }
    set ausrichtung(value) {
        this.model.Ausrichtung = value;
    }
    get einbauart() {
        return this.model.Einbauart;
    }
    set einbauart(value) {
        this.model.Einbauart = value;
    }
    get standard() {
        return this.model.Standard;
    }
    set standard(value) {
        this.model.Standard = value;
    }
    get proAndCons() {
        return this.model.ProAndCons;
    }
    set proAndCons(value) {
        this.model.ProAndCons = value;
    }
    get werkstoff() {
        return this.model.Werkstoff;
    }
    set werkstoff(value) {
        this.model.Werkstoff = value;
    }
    static fromScratch() {
        return new AE({
            ArticleType: echain_product_models_1.ArticleType.ae,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
            ZubehoerRef: [],
        });
    }
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        const msg = 'AE.fromExistingArtNr: ';
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(args.Id, msg + 'Id: '),
            echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: '),
        ]);
        const ae = AE.fromJson(args, cloneStrategy);
        ae.artNrExists = true;
        return ae;
    }
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        const msg = 'AE.fromInventedArtNrArgs: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const ae = AE.fromJson(args, cloneStrategy);
        ae.artNrExists = false;
        return ae;
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const ae = AE.fromScratch();
        ae.fromJson(json, cloneStrategy);
        return ae;
    }
    static fromModel(model) {
        const ae = AE.fromScratch();
        Object.assign(ae.model, model);
        Object.assign(model, ae.model);
        ae.model = model;
        return ae;
    }
    clone() {
        return this._clone(AE.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
    isFestpunktmodulAllowed(festpunktmodul, kette) {
        let isAllowed = false;
        this.zubehoerRef.forEach((z) => {
            isAllowed =
                isAllowed ||
                    (z.montagesetId === festpunktmodul.id && // eslint-disable-line
                        z.kettenSerieId === kette.serieRef.id && // eslint-disable-line
                        kette.innenbreite &&
                        kette.innenbreite.mm >= z.biMin.mm);
        });
        return isAllowed;
    }
    /**
     * Retrieves whether an AE has a C-Profil or not.
     */
    hasCProfil() {
        return Boolean(this.model.HasCProfil);
    }
    /**
     * Retrieves the position of C-Profil in an AE
     */
    getCProfilPosition() {
        if (!this.model.CProfilPosition) {
            return {
                mitnehmer: { t: undefined, b: undefined },
                festpunkt: { t: undefined, b: undefined },
            };
        }
        return this.model.CProfilPosition;
    }
    /**
     * returns true if AE is a KMA else false
     */
    isKMA() {
        return Boolean(this.model.IsKMA);
    }
    /**
     * returns true if AE is a stahl ae else false
     */
    isStahl() {
        return Boolean(this.model.IsStahl);
    }
    /**
     * returns true if AE has a Kamm else false
     */
    hasKamm() {
        return Boolean(this.model.HasKamm);
    }
    /**
     * Ausfuehrung can be used to group AEs in a user-friendly way
     */
    getAusfuehrung() {
        return this.model.Ausfuehrung;
    }
}
exports.AE = AE;
//# sourceMappingURL=AE.js.map